"use client";

import { createContext, useContext } from "react";

interface AddToCartContextValue {
	onAddToProjectClick: (name: string, id?: string) => Promise<void>;
	onAddToCartClick: () => Promise<void>;
	isLoading: boolean;
	isDisabled: boolean;
}

export const AddToCartContext = createContext<AddToCartContextValue>({} as AddToCartContextValue);

export function useAddToCartContext() {
	const context = useContext(AddToCartContext);

	if (context === null) throw new Error("AddToCartContext is not available");

	return context;
}
